<script>
  import {createEventDispatcher} from 'svelte';

  export let msg;

  const dispatch = createEventDispatcher();

  function cancelAlert() {
    dispatch('cancelalert', {
      hash: msg.hash
    })
  }
  </script>

<div class="alert alert-danger clearfix">
    <h4 class="float-start me-3">
        <span class="fas fa-exclamation-triangle"></span>
    </h4>
    <button class="btn btn-outline-danger float-end ms-3" on:click={cancelAlert}>
        <span>×</span>
    </button>

    {msg.msg}

</div>
